module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-tit"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I dedicate this book to my two grandsons: Chester Walton Morris II, “Chet,” and Chandler Reed Sawyer. Chandler is six years older than Chet. Both of those boys started hunting with me at Piney Island Club when each of them got to be seven years old. I still had a gas boat and float box when Chandler was little. When I carried some of the club members across the sound while hunting, I’d take Chandler with me and let him shoot the cripples from the gas boat. He’d stay with me all day long and never complain. He didn’t get to see clouds of ducks like I used to because they weren’t there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Chandler was young, two of the club members from Columbia, South Carolina, got Chandler’s mama to give him a note to get out of school a little early sometimes and go hunting with them in the afternoon and call ducks for them. I’d go pick him up. I just learned they’d slip him a little pocket change, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time Chet came along, I had quit using the gas boat and float box. Chet and his friend, Alex Evans, did get to hunt in it one time and had a good hunt, but they like to hunt in a scissor rig where they can take four or five people hunting at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chet and I have had some good hunts together at Piney Island. He is a good shot and I love to watch him shoot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One time when Chet and I were hunting at Piney Point, Chet was killing his ducks and my gun was hanging up. Chet said, “Granddaddy, it’s time to put that gun in a glass case and buy you a new one.” I decided he was right. My gun was a model 11 Remington that Mr. Joseph P. Knapp had given to Mr. Frank Brumsey in the early 1920s. Daddy bought it from Mr. Frank around 1927 for $65.00.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg8-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_vm._v("Chet Morris (left) and Chandler Sawyer. "), _c('i', [_vm._v("Author’s collection")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg8-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_vm._v("Chandler picking his first duck at Piney Island Club. "), _c('i', [_vm._v("Author’s collection")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg8-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_vm._v("Chet after a morning duck hunt with me at Piney Island Club. "), _c('i', [_vm._v("Author’s collection")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the early 1940s, Mr. Ray Adams, owner of the Whalehead Club, gave daddy a new Belgium Browning, and daddy gave me that old Remington. It was the only gun I had ever had of my very own. The 410 and 20 gauges I was using were loaned to me. The old Browning is now in a glass case on loan to the Wildlife Resource Center in Corolla. I gave the Remington to Chet, and I bought myself a new model 1187 Remington.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I used to take the boys and their friends hunting. Now they take me. I’m still capable of taking myself, but I prefer to go with them because I enjoy their company. They are good shots and I love to watch them shoot.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSSIBLE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I want to thank the following people who shared their stories and pictures to go in this book so they may be preserved for generations to come:")]), _vm._v(" "), _c('p', {
    staticClass: "top-space"
  }), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Mark Marshall and his wife, Melodie")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Louis Davis")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Chandler Sawyer")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Chet Morris")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Frank Helms and his wife, Brenda")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Barry Walker")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Aaron Mathews")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dennis Lee Newbern and Kelly")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("James Guard; his wife, Elaine; their daughter, Amy Blankenship, and her husband, Andy Blankenship")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Larry Williams, for use of the tapes of Blanton Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Last but not least, my daughter, Rhonda Lee Morris. Without her help cleaning up my act and getting things in the order the publisher wants them, this book and five of my previous books would not have been possible.")]), _vm._v(" "), _c('p', {
    staticClass: "top-space"
  }), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As always, I want to give Susan Davis, who wrote "), _c('i', [_vm._v("The Whalehead Club: Reflections of Currituck Heritage")]), _vm._v(", credit for getting me started writing books and helping me get the first one in the order the publisher wanted it. I never had any intention of writing a book until she saw some of the stories I had written and insisted I write a book. Since I wrote the first book, people have been after me to write another one, and I’ve been doing it to preserve a little of Currituck history for future generations.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 69
// module chunks = 0